import { FC, SVGAttributes } from "react";

const FaceNeutralIcon: FC<SVGAttributes<SVGSVGElement>> = ({
  stroke = "#CCCCCC",
  width = 24,
  height = 24,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    width={width}
    height={height}
    style={{ padding: 2 }}
  >
    <g
      strokeWidth="1.4"
      fill="none"
      fillRule="evenodd"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M35.3 18A17.3 17.3 0 1 0 .7 18a17.3 17.3 0 0 0 34.6 0z"></path>
      <path d="M7.88 25.28a12.15 12.15 0 0 1 20.24-.13"></path>
    </g>
  </svg>
);

export default FaceNeutralIcon;
